import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteLight from './paletteLight';
var black = spcColors.black,
    gray = spcColors.gray,
    negative = spcColors.negative,
    accent = spcColors.accent,
    white = spcColors.white,
    light = spcColors.light;

var spcLightPalette = __assign(__assign({}, paletteLight), {
  background: {
    neutral: {
      primary: '#FFFFFF',
      secondary: '#FAF9FC',
      tertiary: '#F1F0F5',
      popover: '#FFFFFF',
      primaryTransparent: 'rgba(255, 255, 255, 0.56)',
      tertiaryTransparent: 'rgba(241, 240, 245, 0.56)',
      dialogOverlay: 'rgba(0, 0, 0, 0.32)'
    },
    semantic: {
      warning: '#FFF2C9',
      accent: '#E8F0FF',
      positive: '#DCF0E8',
      negative: '#FCE3E3',
      positiveGradient: 'linear-gradient(180deg, #17191C 0%, #142B2B 50.47%, #0F4031 100%)',
      negativeGradient: 'linear-gradient(180deg, #29181A 0%, #3B1A1E 50.99%, #63181A 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #FFFFFF 3.5%, rgba(255, 255, 255, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #FAFCFE 3.5%, rgba(250, 252, 254, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #F0F4FA 3.5%, rgba(240, 244, 250, 0) 96.51%)'
    }
  },
  label: {
    accent: '#4A88F2',
    accentHigh: '#3D7CEA',
    accentHighest: '#3D7CEA',
    primary: '#202023',
    secondary: '#797780',
    secondaryHigh: '#4A494F',
    tertiary: '#95929C',
    tertiaryHigh: '#7C7A82',
    placeholder: '#B1AEB8',
    inactive: 'rgba(122, 120, 130, 0.4)',
    positive: '#1B825E',
    negative: '#E83F41',
    warning: '#D49800',
    inverse: '#FFFFFF',
    primaryActive: '#4A88F2',
    secondaryActive: '#4A494F',
    tertiaryActive: '#7C7A82',
    plaseholder: '#B1AEB8'
  },
  fill: __assign(__assign({}, paletteLight.fill), {
    primary: {
      highest: '#3D7CEA',
      high: '#4A88F2',
      mid: '#609AFC',
      low: '#7FAEFF',
      muted: '#ADCBFF',
      overlay32: 'rgba(108, 162, 255, 0.32)',
      overlay24: 'rgba(108, 162, 255, 0.24)',
      overlay16: 'rgba(108, 162, 255, 0.16)',
      overlay8: 'rgba(108, 162, 255, 0.08)'
    }
  }),
  static: __assign(__assign({}, paletteLight.static), {
    primary: '#7CA6F4',
    primaryAlfa32: 'rgba(91, 141, 227, 0.32)'
  }),
  base: {
    accent: accent['1'],
    error: negative['1'],
    disabled: gray['3']
  },
  input: {
    main: {
      text: black['1'],
      background: hexToRgba(gray['1'], 8),
      backgroundDisabled: hexToRgba(gray['1'], 4),
      backgroundHover: hexToRgba(gray['1'], 16),
      backgroundError: hexToRgba(negative['1'], 8),
      border: gray['3'],
      borderDisabled: hexToRgba(gray['3'], 56),
      borderHover: gray['1'],
      borderError: negative['1']
    },
    label: gray['1'],
    message: gray['1']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['1'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(black['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: white['1'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: black['3'],
    secondary: gray['1']
  },
  paper: __assign(__assign({}, paletteLight.paper), {
    background: white['1']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 32)
  },
  dialog: {
    background: white['1']
  },
  dropDown: {
    background: white['1']
  },
  dividerLegacy: {
    primary: light['4'],
    secondary: light['4']
  },
  switch: {
    icon: white['1'],
    shadow: paletteLight.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(gray['1'], 8),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: gray['5'],
    backgroundSecondary: white['2']
  },
  snackbar: {
    text: white['2'],
    background: black['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default spcLightPalette;